import messages from './messages';
import moment from 'moment';
import { type } from 'ramda';

const validate = (values, { intl = {}, error } = {}) => {
  const errors = {};

  if (error?.async) errors._error = error;
  if (!values.notes) errors.notes = intl.formatMessage(messages.notesRequired);

  const toMoment = (v) => (moment.isMoment(v) ? v : moment(v));
  const currentDate = moment();
  const startDate = moment(values.startDate);
  const startTime = toMoment(values.startTime);
  const allDay = !!values.allDay;
  const endDate = moment(startDate);
  const endTime = values.endTime ? toMoment(values.endTime) : null;
  const prospectCreationDate = moment(values.prospectCreationDate);
  let datesValid = true;

  if (!startDate.isValid() || type(values.startDate) === 'String') {
    errors.startDate = intl.formatMessage(messages.invalidDate);
    datesValid = false;
  }

  if (!startTime.isValid() || type(values.startTime) === 'String') {
    errors.startTime = intl.formatMessage(messages.invalidTime);
    datesValid = false;
  }
  if (datesValid) {
    startDate.set({
      hour: startTime.hours(),
      minute: startTime.minutes(),
      second: 0,
      millisecond: 0,
    });

    if (!endTime || !endTime.isValid() || type(values.endTime) === 'String') {
      errors.endTime = intl.formatMessage(messages.invalidTime);
    } else {
      endDate.set({
        hour: endTime.hours(),
        minute: endTime.minutes(),
        second: 0,
        millisecond: 0,
      });
      if (startDate.isAfter(endDate) && !allDay) {
        errors._error = {
          sync: true,
          async: false,
          message: intl.formatMessage(messages.noEndDateBeforeStartDate),
        };
      }
    }
  }

  if (
    values.activityCompletionStatusId &&
    currentDate.isBefore(startDate.format())
  ) {
    errors._error = {
      sync: true,
      async: false,
      message: intl.formatMessage(messages.futureActivityDate),
    };
  }

  const sevenDaysAfterStart = startDate
    .clone()
    .utc()
    .startOf('day')
    .add(7, 'days');
  const prospectDateOnly = prospectCreationDate.clone().utc().startOf('day');
  if (sevenDaysAfterStart.isBefore(prospectDateOnly)) {
    errors._error = {
      sync: true,
      async: false,
      message: intl.formatMessage(messages.tooFarPast),
    };
  }

  return errors;
};

export default validate;
